import type {
  GetSettings200AimManualApplicationsItem,
  PatchSettingsBodyAimManualApplicationsItem,
} from '@ipfabric/api-client/client/schemas';
import type { FormSnippet } from '@ipfabric/ui-components/utils/formSnippets/FormSnippet';
import { z } from 'zod';
import { AimApplicationsTable } from '../components/ApplicationMapping/tables/AimApplicationsTable';
import type { DiscoverySettingsObject } from '../model/DiscoverySettingsObject';
import type { AimApplicationDraft } from '../model/aimDrafts';

type AimApplicationsFieldValues = { aimApplications: AimApplicationDraft[] };

export const storedAimApplications: FormSnippet<
  DiscoverySettingsObject,
  AimApplicationsFieldValues
> = {
  render: ({ form }) => <AimApplicationsTable form={form as never} />,

  fromModel: (model, draft) => {
    draft.aimApplications = (model.aim?.manual?.applications ?? []).map(
      (a) => ({
        id: a.id,
        name: a.name,
        environment: a.environment,
      }),
    );
  },

  toModel: (values, modelDraft) => {
    modelDraft.aim ??= {
      integrations: [],
      manual: { applications: [], workloads: [], flows: [] },
    };
    modelDraft.aim.manual ??= { applications: [], workloads: [], flows: [] };
    // PATCH DTO omits server-generated timestamps; cast to satisfy the model
    // field type (GetSettings200AimManualApplicationsItem[]) which the immer draft uses.
    modelDraft.aim.manual.applications = values.aimApplications.map(
      (a): PatchSettingsBodyAimManualApplicationsItem => ({
        id: a.id,
        name: a.name,
        environment: a.environment,
      }),
    ) as GetSettings200AimManualApplicationsItem[];
  },

  schema: z.object({
    aimApplications: z.array(z.unknown()),
  }) as z.Schema<AimApplicationsFieldValues>,
};
